import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { translate } from 'react-i18next'
import { compose, pure, withHandlers } from 'recompose'
import styles from './loginForm.scss'
import FloatLabelInput from '../components/floatLabelInput/floatLabelInputComponent'
import SmartErrorMessage from '../containers/loginErrorMessage/loginErrorMessageContainer'
import TogglePassword from '../components/togglePassword/togglePasswordComponent'
import { actionCreators as loginActions } from '../../redux/reducers/login/loginReducer'
import { actionCreators as uiActions } from '../../redux/reducers/ui/uiReducer'
import { actionCreators as sagaActionCreators } from '../../redux/sagas/index'
import { loginValidator } from 'tmw-validation'
import PropTypes from 'prop-types'

export function LoginForm (props) {
  const { t, handleSubmit } = props
  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <header>
        <h1 className={styles.modalHeader}>
          {t('form:signIn')}
          <small>{t('form:withTexasOncourse')}</small>
        </h1>
      </header>
      <Field
        name='email'
        component={FloatLabelInput}
        placeholder={t('form:placeholderEmail')}
        type='email'
        wrapperStyle={styles.formGroup}
        label={t('form:email')}
      />
      <div className={styles.formRow}>
        <Field
          name='password'
          component={FloatLabelInput}
          placeholder=' '
          wrapperStyle={[styles.formGroup, styles.password].join(' ')}
          type={props.showPasswordValue ? 'input' : 'password'}
          label={t('form:password')}
        />

        <Field
          wrapperStyle={styles.hiddenPassword}
          component={TogglePassword}
          name='showPasswordLogin'
          type='checkbox'
          id='showPasswordLogin'
        />
      </div>

      <SmartErrorMessage />

      <div className={styles.row}>
        <button
          onClick={props.forgotPasswordClick}
          type='button'
          className={[styles.linkButton, styles.alignEnd].join(' ')}
        >
          <span>{t('form:forgotPassword')}</span>
        </button>
      </div>

      <button type='submit' className={styles.signInButton}>
        {t('form:signIn')}
      </button>

      <p className={styles.noMargin}>
        {t('form:feelingLeftOut')}
        <button
          type='button'
          onClick={props.createAccountClick}
          className={styles.linkButton}
        >
          <span>{t('form:createAccount')}</span>
        </button>
      </p>

      <p className={styles.noMargin}>
        <span style={{fontSize: '10pt'}}>
          {t('form:supportHavingTrouble')}
          <span style={{paddingLeft: '0.5em'}}>
            <a rel='noopener noreferrer' target='_blank' href='mailto:TexasOnCourseSupport@highered.texas.gov?subject=MapMyGrad Support Request'>{t('form:supportContactSupport')}</a>
          </span>
        </span>
      </p>

    </form>
  )
}

const selector = formValueSelector('login')

const boundActions = {
  hideLogin: loginActions.hideLogin,
  showRegister: uiActions.toggleRegistrationModal,
  onSubmit: sagaActionCreators.authActionCreators.login,
  showResetPassword: uiActions.toggleResetPassModal
}

LoginForm.propTypes = {
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  showPasswordValue: PropTypes.bool,
  createAccountClick: PropTypes.func.isRequired,
  forgotPasswordClick: PropTypes.func.isRequired
}

export const handlers = {
  createAccountClick: props => () => {
    props.hideLogin()
    props.showRegister()
  },
  forgotPasswordClick: props => () => {
    props.hideLogin()
    props.showResetPassword()
  }
}
export default compose(
  pure,
  translate(),
  connect(state => {
    const showPasswordValue = selector(state, 'showPasswordLogin')
    return {
      showPasswordValue
    }
  }, boundActions),
  withHandlers(handlers),
  reduxForm({
    validate: loginValidator,
    form: 'login'
  })
)(LoginForm)



// WEBPACK FOOTER //
// ./src/forms/login/loginForm.js